import React from 'react';
import { Chip, Avatar, Typography } from '@mui/material';

function FilterChip({
  selected,
  onClick,
  label,
  count,
  rightIcon,
  value,
}) {
  return (
    <Chip
      clickable
      avatar={
      count
        ? <Avatar>{count}</Avatar>
        : null
}
      color="primary"
      onClick={() => onClick(value)}
      variant={selected ? 'default' : 'outlined'}
      label={<Typography variant="body2" color="inherit">{label}</Typography>}
      deleteIcon={rightIcon || <div />}
      sx={{ ml: 0.5, mb: 0.5 }}
    />
  );
}

export default FilterChip;
